import { slab, roof, wallX, wallZ, sign, neon, checkpoint, shard, goal,
  edgeLights, emitter, receptacle, gate } from '../kit.js';

export default {
  id: 'relay', name: 'RELAY', unlockAfter: 'crossflow',
  blurb: 'Power the door. Rebuild the pair. Take the upper route home.',
  mode: { type: 'collect', par: 180 },
  redline: { seconds: 162 },
  spawn: { p: [-8, 24.4, 14], yaw: 0 }, killY: -90,
  env: { fog: 0x121820, fogDensity: 0.0015, floorY: -160,
    sky: { zenith: 0x060912, horizon: 0x283544, glow: 0x39576e, aurora: 0x396b62 } },
  objects: [
    // A complete teach chamber, not the four-chapter finale yet.
    slab(12, -40, -22, 72, 100, 'panel'), roof(12, 96, -22, 72, 100, 'trim'),
    wallX(-24.6, -40, -22, 100, 136, 'plate'), wallX(48.6, -40, -22, 100, 136, 'plate'),
    wallZ(12, -40, -72.6, 74.4, 136, 'plate'), wallZ(12, -40, 28.6, 74.4, 136, 'plate'),

    slab(0, 24, 0, 32, 48), roof(0, 40, 0, 32, 48, 'trim'),
    wallX(-16.6, 24, 0, 48, 16, 'plate'), wallX(16.6, 24, 0, 48, 16, 'plate'),
    wallZ(0, 24, 24.6, 34.4, 16, 'plate'),
    wallZ(-10, 24, -24.6, 12, 16, 'plate'), wallZ(10, 24, -24.6, 12, 16, 'plate'),
    gate(0, 24, -24.6, 'intake', 8, 16),
    // Blue panels sit proud of the solid room walls, facing the beam path.
    wallX(15.8, 24, -4, 10, 10, 'panel', 0.4),
    wallZ(0, 24, 18.6, 10, 12, 'panel'),
    emitter(-12, 27, -4, [1, 0, 0]), receptacle(0, 27, 2, 'intake'),
    sign(-8, 27.4, 8, 0, ['RELAY // CHAMBER ONE', 'ROUTE AMBER INTO THE SOCKET', 'GREEN OPENS THE DOOR'], '#ffb020'),
    sign(0, 27.4, -16, 0, ['ONE PORTAL AT THE BEAM IMPACT', 'ONE ON THE BLUE WALL BEHIND', 'KEEP THE FEED WHILE YOU CROSS'], '#ffb020'),
    shard(-8, 25.6, -12), checkpoint(-8, 24, -12),
    neon(-8, 24.07, 0, [0.16, 0.1, 30], 'amber'),
    neon(-4, 24.07, -12, [8, 0.1, 0.16], 'amber'),
    neon(0, 24.07, -20, [0.16, 0.1, 16], 'amber'),

    // The checkpoint is beyond the powered door. A missed launch can be
    // retried after replacing either portal without reopening the intake.
    slab(0, 24, -34, 24, 20), ...edgeLights(0, 24, -34, 24, 20),
    shard(0, 25.6, -34), checkpoint(0, 24, -34),
    sign(0, 27.4, -40, 0, ['REBUILD THE PAIR', 'EXIT: BLUE FLOOR TO YOUR RIGHT', 'ENTRY: DEEP FLOOR AHEAD']),
    slab(28, 24, -8, 6, 6, 'panel'), ...edgeLights(28, 24, -8, 6, 6),
    neon(0, 24.08, -44, [10, 0.12, 0.2], 'amber'),
    neon(46, 20, -40, [0.14, 104, 0.14], 'cyan'),

    slab(28, 64, 16, 24, 24), ...edgeLights(28, 64, 16, 24, 24, 'lime'),
    shard(28, 65.6, 12), checkpoint(28, 64, 12, 90),
    slab(8, 64, 12, 24, 8), ...edgeLights(8, 64, 12, 24, 8, 'lime'),
    sign(16, 67.4, 12, 90, ['THE CIRCUIT HELD', 'YOUR ENTRANCE IS BELOW'], '#9dff3c'),
    goal(0, 64, 12, 90),
  ],
};
